var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { action } from 'mobx';
import { numFormat } from '../../helpers';
import { BaseModel } from './../../libraries';
export class InfoController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
    }
    getTheme() {
        const activeTheme = Mudu.Room.GetActiveTheme();
        const allTheme = Mudu.Room.GetThemes();
        return lodash.find(allTheme, ['name', activeTheme]);
    }
    get value() {
        return this.Model.value;
    }
    get theme() {
        return lodash.get(this.value, 'theme');
    }
    get cover() {
        return lodash.get(this.theme, 'cover_img');
    }
    get banner() {
        return lodash.get(this.theme, 'banner');
    }
    get bgColor() {
        return lodash.get(this.theme, 'bg_color');
    }
    get roomName() {
        return lodash.get(this.value, 'roomName');
    }
    get roomNum() {
        return lodash.get(this.value, 'roomNum');
    }
    get liveStatus() {
        return lodash.get(this.value, 'liveStatus');
    }
    get videoId() {
        return lodash.get(this.value, 'videoId');
    }
    get playAddr() {
        return lodash.get(this.value, 'playAddr');
    }
    get liveImage() {
        return lodash.get(this.value, 'liveImage');
    }
    get videoUrl() {
        return lodash.get(this.value, 'videoUrl');
    }
    async getVideoUrl(videoId) {
        let videoUrl;
        try {
            const res = await Mudu.Room.GetVideoInfo(videoId);
            videoUrl = res.url;
        }
        catch (error) {
            videoUrl = '';
        }
        return videoUrl;
    }
    getPlayAddr() {
        const config = Mudu.Room.GetListLiveConfig();
        if (config.inUse) {
            return lodash.get(config, 'address');
        }
        else {
            return Mudu.Room.GetPlayAddr();
        }
    }
    //直播间ID
    /**
     * @description: 设置直播间信息
     */
    onSetRoomInfo() {
        const liveStatus = Mudu.Room.GetLiveStatus();
        const theme = this.getTheme();
        const roomName = Mudu.Room.GetName();
        const roomNum = Mudu.Room.GetViewNum();
        const videoId = Mudu.Room.GetTrailer().video_id;
        const playAddr = this.getPlayAddr();
        const liveImage = Mudu.Room.GetLiveImage();
        // const roomPlayAddrList = Mudu.Room.GetStreamList();
        // const videoUrl = await this.getVideoUrl(videoId)
        this.Model.merge({
            // videoUrl,
            theme,
            roomName,
            roomNum: numFormat(roomNum),
            liveStatus,
            videoId,
            playAddr,
            liveImage,
        });
    }
}
__decorate([
    action.bound
], InfoController.prototype, "onSetRoomInfo", null);
